@if (invites && invites.length) {
  <div class="m-b-50">
    <h4 class="section-header is-grid">{{ "sphere.workspaces.collaboration_invitations" | translate }}</h4>
    <span class="d-block t-14 text-left">{{ "sphere.workspaces.your_invites" | translate }}</span>
    <br />
    @for (item of invites; track item) {
      <myp-list-item
        [photo]="item.workspace.image || './assets/icons/workspace.png'"
        [title]="item.workspace.name"
        [imageRound]="false"
        [subData]="[('sphere.workspaces.invited_by' | translate) + ' ' + item.workspace.owner_name + ' (' + item.workspace.owner_email + ')']"
        [includeChevron]="false"
      >
        <div class="button-content">
          @if (!item.loading) {
            <fa-icon icon="check" placement="left" (click)="handle(true, item)" [ngbTooltip]="'sphere.workspaces.accept' | translate" class="action blue circle-icon-btn m-r-10"></fa-icon>
          }
          @if (!item.loading) {
            <fa-icon icon="times" placement="left" (click)="handle(false, item)" [ngbTooltip]="'sphere.workspaces.reject' | translate" class="action circle-icon-btn m-r-10"></fa-icon>
          }
          @if (item.loading) {
            <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
          }
        </div>
      </myp-list-item>
    }
  </div>
}
